import React, { useEffect, useState, useRef } from 'react'

// next components

// swiper
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'

// custom functions
import { useViewport } from 'utils'

// resources
import { HomePrevButton } from 'components/Button/HomePrevButton'
import { HomeNextButton } from 'components/Button/HomeNextButton'

// styles
import styles from './index.module.scss'

// call apis
import dashboardAPI from 'apis/dashboard'
import SpotlightCard from 'components/Card/SpotlightCard'
import SpotlightCardMobile from 'components/Card/SpotlightCardMobile'

const SpotlightSection = props => {
  const {} = props
  const viewport = useViewport()
  const [spotlightList, setSpotlightList] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const swiperRef = useRef(null)

  const fetchShopPhysical = async () => {
    try {
      setIsLoading(true)
      const response = await dashboardAPI.getFeedData('creator-spotlight')
      if (response && Array.isArray(response.cards)) {
        setSpotlightList(response.cards)
      }
    } catch (error) {
      console.error('Error fetching shop physical data:', error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchShopPhysical()
  }, [])

  useEffect(() => {
    if (!isLoading && swiperRef.current && spotlightList.length > 0) {
      // Use setTimeout to ensure DOM is fully rendered before repositioning
      const timer = setTimeout(() => {
        if (swiperRef.current) {
          // Force swiper to update and reposition slides after data loads
          swiperRef.current.update()
          swiperRef.current.slideToLoop(0, 0, false)
        }
      }, 100)
      return () => clearTimeout(timer)
    }
  }, [isLoading, spotlightList.length])

  const handlePrev = () => {
    if (swiperRef.current) {
      swiperRef.current.slidePrev()
    }
  }

  const handleNext = () => {
    if (swiperRef.current) {
      swiperRef.current.slideNext()
    }
  }

  return (
    <section className={styles.container}>
      <div className="w-full h-[60px] g-container md:flex hidden justify-between items-center">
        <div className={styles.headerContent}>
          <div className={styles.title}>
            Creator&nbsp;<span className={styles.spotlight}>Spotlight</span>
          </div>
        </div>
        <div className="flex items-end gap-5">
          <HomePrevButton onClick={() => handlePrev()} />

          <HomeNextButton onClick={() => handleNext()} />
        </div>
      </div>

      <div className="block md:hidden w-full h-[60px]">
        <div className={styles.headerContent}>
          <div className={styles.title}>
            Creator&nbsp;<span className={styles.spotlight}>Spotlight</span>
          </div>
        </div>
      </div>

      <div className={`w-full md:block hidden mt-[45px]`}>
        <Swiper
          navigation={viewport === 'md' || viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? true : false}
          slidesPerView={viewport === 'sm' || viewport === 'md' ? 1.58 : 1.2}
          spaceBetween={viewport === 'lg' || viewport === 'xl' || viewport === '2xl' ? 20 : viewport === 'md' ? 11 : 11}
          centeredSlides={true}
          loop={spotlightList.length > 1}
          modules={[Navigation]}
          className={'heroMobileNavigationSwiper'}
          initialSlide={0}
          onSwiper={swiper => {
            swiperRef.current = swiper
            // Update swiper position after initialization if data is loaded
            if (spotlightList.length > 0 && !isLoading) {
              setTimeout(() => {
                if (swiper) {
                  swiper.update()
                  if (swiper.slideToLoop) {
                    swiper.slideToLoop(0, 0, false)
                  }
                }
              }, 50)
            }
          }}
        >
          {spotlightList.map((item, index) => (
            <SwiperSlide key={index}>
              {viewport === 'sm' || viewport === 'md' ? (
                <div className="w-full aspect-[519/746]">
                  <SpotlightCardMobile data={item} />
                </div>
              ) : (
                <SpotlightCard data={item} />
              )}
            </SwiperSlide>
          ))}
        </Swiper>
        {/* <div className={styles.moreSpotlight}>More Spotlights</div> */}
        {/* <div className="w-full flex gap-[20px]">
          {spotlightList.slice(0, 4).map((item, index) => (
            <div key={index} className="flex gap-[20px]">
              <div className="w-[170px] h-[100px]">
                <ImageWithFoster
                  src={item.creatorStoreUrl}
                  width={170}
                  height={100}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="max-w-[200px] flex flex-col gap-[15px]">
                <div className={styles.itemTitle}>{item.name}</div>
                <Link href={`/${item.creatorUsername}`} passHref>
                  <a>
                    <div className={styles.itemUsername}>{item.creatorUsername}</div>
                  </a>
                </Link>
              </div>
            </div>
          ))}
        </div> */}
      </div>
      {/* Mobile */}
      <div className={`w-full md:hidden flex gap-[15px] overflow-x-auto mt-[30px] px-[16px] ${styles.hideScrollbar}`}>
        {spotlightList.map((item, index) => (
          <div key={index} className="max-w-[96%] min-w-[96%] aspect-[380/546] overflow-hidden">
            <SpotlightCardMobile data={item} />
          </div>
        ))}
      </div>
    </section>
  )
}

export default SpotlightSection
